import type { SVGProps } from "react";
// generated from ChartUp.svg — do not edit manually
// prettier-ignore
export default function ChartUp(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 3 15 V 21 H 21 V 9 M 3 15 V 3 H 21 V 9 M 3 15 L 10 10 L 14 14 L 21 9" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
